import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Spinner } from 'reactstrap';
import { GET_REFERRAL_DATA } from '../../query/query';

const ReferralInfos = ({ userId }) => {
  const {
    data: { savGetReferralData: { discountCode, godsons = [] } = {} } = {},
    loading,
  } = useQuery(GET_REFERRAL_DATA, {
    fetchPolicy: 'cache-and-network',
    variables: { userId },
  }) || {};

  if (loading) return <Spinner color="primary" />;
  return (
    <div>
      <h5>Referral</h5>
      <ul>
        <li>{`Discount code: ${discountCode || '-'}`}</li>
        <li>
          Referrees:
          {godsons.length > 0
            ? (
              <ul>
                {godsons.map(({ email = '', rewardCodes = [] }) => (
                  <li key={email}>{`${email} - ${rewardCodes[0]}`}</li>
                ))}
              </ul>
            )
            : ' -'}
        </li>
      </ul>
    </div>
  );
};

export default ReferralInfos;



// WEBPACK FOOTER //
// ./src/components/user-info/referral-infos.js